// TODO: find a better place for this
export const collectDefaultMetrics = null;

export default {};
